import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { BADGE_ICON_POSITIONS, BADGE_VARIANTS } from "./constants";

const booleanAttributeDefaultTrue = z
  .string()
  .optional()
  .transform((value) => value === undefined || value !== "false");

export const badgeDataSchema = z.object({
  variant: z.enum(BADGE_VARIANTS).optional(),
  size: z.enum(SIZES).optional(),
  label: z.string().optional(),
  icon: z
    .string()
    .optional()
    .describe("Optional Lucide icon name shown in place of the dot."),
  dot: booleanAttributeDefaultTrue.describe(
    'Set to "false" for a badge that carries a count, where the dot says nothing.',
  ),
  iconPosition: z.enum(BADGE_ICON_POSITIONS).optional(),
  href: z.string().optional(),
  target: z.string().optional(),
  rel: z
    .string()
    .optional()
    .describe(
      'Defaults to "noopener noreferrer" when target is "_blank", so a new tab cannot reach back into this one.',
    ),
});

export type BadgeDataProps = z.infer<typeof badgeDataSchema>;
